import React from "react";
import { PreviewLayout } from "./";
import { Typography } from "@components/Typography";
import { IconList } from "@components/IconList";
import { Button } from "@components/Button";
import { Lazy } from "@/components/Lazy";
import { checkValidURL } from "@/utils/formHelper";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";
import { isClient } from "@/utils/browser";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";

export default function PreviewWebsite(props: QRProps<"website">) {
  const qrEditorContext = React.useContext<QREditorContextProps<"website">>(QREditorContext);
  const data = props?.data || qrEditorContext?.qrData.data;
  const isInitPreview = props?.initPreview;

  return (
    <PreviewLayout
      page="website"
      backgroundColor={data?.themeColor?.backgroundColor}
      dataQA="preview-website-container"
      includeBrowser
      isInitPreview={isInitPreview}>
      {data?.companyName && (
        <div className="website-companyName">
          <Typography
            Tag="p"
            classname="u-bold"
            size="s">
            {data?.companyName}
          </Typography>
        </div>
      )}

      <div style={{ position: "relative" }}>
        {data.logoUrl && (
          <div className="website-logo--container">
            <Lazy placeholderClass="website-logo--background">
              <img
                src={optimizeCloudinaryImage({
                  url: data?.logoUrl,
                  transformations: ["f_auto,q_auto,w_1280,h_640,dpr_auto,c_fill"],
                })}
                className="website-logo--background"
              />
            </Lazy>
          </div>
        )}
        <div className="background-divider-bottom">
          <div className={`qr-content ${data.logoUrl ? "hasLogo" : ""} `}>
            {data?.title && (
              <div className="website-title">
                <Typography
                  Tag="p"
                  size="l"
                  classname="u-bold u-spacing-4">
                  {data?.title}
                </Typography>
              </div>
            )}

            {data?.subtitle && (
              <div className="website-subtitle">
                <Typography
                  Tag="p"
                  size="s"
                  classname="u-spacing-5">
                  {data?.subtitle}
                </Typography>
              </div>
            )}

            {data?.buttonText && (
              <Button
                customClass="u-spacing-5 website-button"
                label={data?.buttonText}
                buttonColor={data?.themeColor?.buttonColor}
                onClick={() =>
                  (isClient() && window.open(checkValidURL(data?.buttonUrl), "_blank")) || ""
                }
              />
            )}

            {isInitPreview && (
              <div className="initPreview-logos">
                {data?.socialLogos?.map((socialLogo) => (
                  <Lazy
                    key={socialLogo}
                    placeholderClass="skeleton-placeholder__website__logo">
                    <img
                      key={socialLogo}
                      src={socialLogo}
                      alt="social media logo"
                    />
                  </Lazy>
                ))}
              </div>
            )}
            {data?.socialNetworks?.length > 0 && (
              <div className="website-icons">
                <IconList
                  center
                  items={data?.socialNetworks}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </PreviewLayout>
  );
}
